module.exports = __webpack_public_path__ + "static/img/redmiK30Pro.0cb2e00f.png";